import React from 'react';
import { ListItem, ListItemText } from 'material-ui/List';

const CheckoutClient = ({ data }) => {
    const payload = data.payload || {};
    const customer_name = payload.customer_name || 'Sem cliente';
    const address_data = JSON.parse(payload.customer_address || '{}');
    const value = JSON.parse(payload.value || '{}');
    const address = `${address_data.address}, ${address_data.district}, ${address_data.city} - ${address_data.state}`;

    const openMap = e => {
        const lat = value.latitude;
        const lng = value.longitude;

        window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_blank');
    }

    return (
        <ListItem onClick={openMap} button>
            <i className="material-icons" style={{color: '#ec1a12'}}>pin_drop</i>
            <ListItemText primary={`Realizou checkout em: ${customer_name}`} secondary={address} />
        </ListItem>
    );
};

export default CheckoutClient;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/CheckoutClient.js